import { render, staticRenderFns } from "./PaymentTypesBlock.vue?vue&type=template&id=19fa62ac"
import script from "./PaymentTypesBlock.vue?vue&type=script&lang=js"
export * from "./PaymentTypesBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports